import ONE_PALETTE from './images/1palette.jpg';
import ELI from './images/eli.jpg';
import DOM from './images/dom.jpg';
import LONGDO_SDK from './images/longdo_sdk.jpg';
import LONGDO_PANO from './images/longdo_pano.jpg';
import DOL from './images/dol.jpg';
import RM from './images/rm.jpg';
import LONGDO_ANDROID from './images/longdo_android.jpg';
import LONGDO_TRAFFIC from './images/longdo_traffic.jpg';
import PROMPTPAI from './images/promptpai.jpg';
import CITIZEN from './images/citizen.jpg';
import TAGGERBOT from './images/taggerbot.jpg';
import MJPEG_LIB from './images/android_mjpeg.jpg';
import GISTDA_GO from './images/gistda_go.jpg';
import CAMERA_SERVER from './images/camera_server.jpg';
import RAPID_MINER from './images/rapid_miner.jpg';
import PHD_THESIS from './images/phd_thesis.png';
import MIMO from './images/mimo.jpg';
import POMELO_ANDROID from './images/pomelo_android.jpg';
import POMELO_IOS from './images/pomelo_ios.jpg';
import OOCA_IOS from './images/ooca_ios.jpg';
import STAYGOLD from './images/staygold.jpg';
import HR from './images/hr.jpg';
import CENT from './images/cent.jpg';
import BRIAN from './images/brian.jpg';
import ALICE from './images/alice.jpg';
import SENA from './images/sena.jpg';
import ITIM from './images/itim.jpg';
import ONEPAGE from './images/onepage.jpg';
import CROSS_SECTION from './images/cross_section.jpg';
import POKOO from './images/pokoo.jpg';
import TENCENT_CLOUD from './images/tencentcloud.png';
import CLICKHOUSE from './images/clickhouse.png';

export const cards = [
  {
    title: 'Pokoo Application',
    desc: 'A personal application project that help tracking daily expenses',
    detail:
      'Pokoo is a personal finance mobile application that helps users track their daily expenses, manage budgets, and gain insights into their spending habits. The app aims to promote better financial management and awareness through intuitive tracking and reporting features.',
    imageUrl: POKOO,
    url: 'https://apps.apple.com/th/app/pokoo/id6804015981',
    tags: ['Flutter', 'Golang', 'GCP', 'LLM', 'Jev'],
    year: 2026,
  },
  {
    title: 'StayGold Application',
    desc: 'A longevity app with built-in social media and daily health activity tracking',
    detail:
      'StayGold is a longevity-focused mobile application that combines a social media platform with health activity tracking. Users can connect with friends, share their wellness journey, and monitor daily health activities to hit personal targets — all designed to encourage consistent healthy habits and a longer, better quality of life.',
    imageUrl: STAYGOLD,
    url: 'https://apps.apple.com/th/app/staygold/id6752633992',
    tags: [
      'Flutter',
      'Golang',
      'Tencent Cloud',
      'LLM',
      'Chatbot',
      'Bluetooth',
      'Wearable device',
    ],
    year: 2026,
  },
  {
    title: 'Ooca applications, APIs and infrastructure',
    desc: 'The most impactful mental wellness platform in ASEAN',
    detail:
      'We provider online counselling and many other services to help improve people mental wellbeing.',
    imageUrl: OOCA_IOS,
    url: 'https://apps.apple.com/th/app/ooca-%E0%B8%9B%E0%B8%A3-%E0%B8%81%E0%B8%A9%E0%B8%B2%E0%B8%9B-%E0%B8%8D%E0%B8%AB%E0%B8%B2%E0%B9%83%E0%B8%88/id1260476046?l=th',
    tags: ['Flutter', 'Golang', 'GCP', 'LLM', 'Chatbot', 'Video call'],
    year: 2023,
  },
  {
    title: 'Pomelo applications',
    desc: "Southeast Asia leading fashion-tech company's native applications (iOS and Android)",
    detail:
      'Provide the best shopping experience on Omni-channel for fashion industry.',
    imageUrl: POMELO_IOS,
    url: 'https://apps.apple.com/th/app/pomelo-fashion/id1098083916',
    tags: ['Swift', 'Kotlin', 'Flutter'],
    year: 2021,
  },
  {
    title: 'Pomelo API and DevOps',
    desc: 'Backend services and infrastructure to support frontend clients and internal tools',
    detail: 'Fast, secure and reliable APIs. Auto scale during campaigns',
    imageUrl: POMELO_ANDROID,
    url: 'https://play.google.com/store/apps/details?id=com.mobile.pomelo&hl=en_US',
    tags: ['Node.js', 'Terraform', 'ECS', 'WAF', 'RDS', 'CF', 'Redis'],
    year: 2021,
  },
  {
    title: '1palette',
    desc: 'Facebook ads audience targeting',
    detail:
      'Sync data (e.g. posts, messages, comments) from Facebook Fanpage. Automatically classify customer into segments based on chat messages and activities on Fanpage. Send them back to Facebook to be used as ads audiences for appropriate strategy and content.',
    imageUrl: ONE_PALETTE,
    url: 'https://1palette.insightera.co.th/',
    tags: [
      'Python',
      'Golang',
      'Tensorflow',
      'Vue.js',
      'Mongo',
      'Facebook API',
      'RabbitMQ',
    ],
    year: 2019,
  },
  {
    title: 'NLP APIs',
    desc: 'Natural Language Processing APIs',
    detail:
      'Similar to LLM APIs today, back in 2021 when ChatGPT was not yet available, we developed NLP APIs to process and analyze text data for various applications e.g. sentiment analysis, entity recognition, text classification and text generation',
    imageUrl: ELI,
    url: 'https://demo.nlp.insightera.co.th/',
    tags: ['Python', 'Tensorflow', 'NLP', 'ML', 'scikit-learn'],
    year: 2019,
  },
  {
    title: 'DOM',
    desc: 'Social Listening and Analytics',
    detail:
      'Gather data from multiple social media--Facebook, Twitter, Youtube, Instagram, Pantip and News website. Analyze data to determine overall sentiment and incidents. Generate reports consist of summary and recommendation.',
    imageUrl: DOM,
    url: 'https://www.insightera.co.th/dom/',
    tags: [
      'Golang',
      'Node.js',
      'Mongo',
      'Redis',
      'Wordpress API',
      'Facebook API',
      'RabbitMQ',
      'Elasticsearch',
      'Puppeteer',
    ],
    year: 2019,
  },
  {
    title: 'CENT',
    desc: 'Social medial Management Tool',
    detail:
      'Manage multiple social media in one place. Also include features to facilitate practical operations--ticketing, task assignment and content scheduling.',
    imageUrl: CENT,
    url: 'https://cent.insightera.co.th/',
    tags: ['Product design', 'SCRUM Master'],
    visible: false,
    year: 2019,
  },
  {
    title: 'BRIAN',
    desc: 'Digital Marketing Competitor Analysis',
    detail:
      'Monitor competitor activities e.g. campaign, PR, traffic and ads. Summarize on easy to understand dashboards.',
    imageUrl: BRIAN,
    url: 'https://www.insightera.co.th/brian/',
    tags: [
      'Product design',
      'Node.js',
      'Puppeteer',
      'Google ads',
      'Facebook ads',
    ],
    visible: false,
    year: 2019,
  },
  {
    title: 'ALICE',
    desc: 'Chatbot Development Tool',
    detail:
      'Internal tool to help developing chatbot for project implementation business. GUI to help train model, analyze conversation flow.',
    imageUrl: ALICE,
    url: 'https://www.insightera.co.th/alice/',
    tags: ['Product design', 'SCRUM Master', 'NLP'],
    visible: false,
    year: 2019,
  },
  {
    title: 'Branding websites',
    desc: 'Wordpress website for brands',
    detail:
      'Websites developed using Wordpress. Some customization to fit customer needs. Mostly used as branding websites. Cover various industries e.g. real estate, hospital, private company and retail',
    imageUrl: SENA,
    url: 'https://www.sena.co.th/',
    tags: ['Resource Management', 'Technical Advise'],
    visible: false,
    year: 2019,
  },
  {
    title: 'HR Analytics',
    desc: 'HR software and analytics dashboard',
    detail:
      'Build on top of MS Office365 platform--Power App, Power Automate, PowerBI and SharePoints to provide one stop services for HR team.',
    imageUrl: HR,
    url: 'https://course-gable-openedx.web.app/',
    tags: ['Product Owner', 'Rapid prototype', 'React.js', 'Python', 'OpenEdx'],
    visible: false,
    year: 2019,
  },
  {
    title: 'Longdo Map Android',
    desc: 'Android Application of Longdo Map',
    detail:
      'Application provide map functionality and other geographic related tasks e.g. POI search, navigation, check-in and add/edit/remove POI.',
    imageUrl: LONGDO_ANDROID,
    url: 'https://play.google.com/store/apps/details?id=com.longdo.map.android',
    tags: ['Java', 'Kotlin', 'Map SDK', 'OpenGL ES2.0'],
    year: 2018,
  },
  {
    title: 'Longdo Traffic Android',
    desc: 'Android Application of Longdo Traffic',
    detail:
      'Application provide map functionality especially functions related to current traffic conditions e.g. traffic index and view live traffic cameras',
    imageUrl: LONGDO_TRAFFIC,
    url: 'https://play.google.com/store/apps/details?id=com.longdotraffic.android',
    tags: ['Java', 'Kotlin', 'Map SDK', 'OpenGL ES2.0'],
    year: 2018,
  },
  {
    title: 'Promptpai',
    desc: 'Android Application of Promptpai',
    detail:
      'Use Phone No as a representation of personal address similar to how Phone No can be used to represent a personal bank account in Promptpay',
    imageUrl: PROMPTPAI,
    url: 'https://play.google.com/store/apps/details?id=com.promptpai.promptpai',
    tags: ['Java', 'Kotlin', 'Map SDK', 'Androidx'],
    year: 2018,
  },
  {
    title: 'Longdo Map Android SDK',
    desc: 'Android SDK to integrate Longdo Map into applications',
    detail:
      'Android SDK which enable developers to easily integrate Longdo Map into their applications by providing SDK. The SDK consist of basic map functionality, geographic related operation--measure distance and view public traffic cameras. Also include adding 3D models to show on a Map.',
    imageUrl: LONGDO_SDK,
    url: 'https://map.longdo.com/api-mobile/android/document/index.html',
    tags: ['Java', 'OpenGL ES2.0'],
    year: 2018,
  },
  {
    title: 'Longdo Panorama SDK',
    desc: 'Google Streetview liked by Longdo Map',
    detail:
      'Web library which enable web developer to easily integrate panorama view (Google Streetview-liked) into their websites. Provide basic panorama functionality e.g. pan, zoom, move and go to next frame. Also include basic 3D geographic operation e.g. measure distance in 3D and add 3D models. Support render point cloud on the scene',
    imageUrl: LONGDO_PANO,
    url: 'https://api.longdo.com/pano/',
    tags: ['Vanilla JS', 'WebGL'],
    year: 2018,
  },
  {
    title: 'CitizenInfo Android App',
    desc: 'Android application by DGA provide useful information for citizens',
    detail:
      'An application provide detailed information of each government institution e.g. available services, documents required for each services and search and filter nearby offices with specific services.',
    imageUrl: CITIZEN,
    url: 'https://play.google.com/store/apps/details?id=th.go.info.citizeninfo',
    tags: ['Java', 'Kotlin', 'Map SDK'],
    year: 2017,
  },
  {
    title: 'DRR - RM',
    desc: 'Rural Road Management System',
    detail:
      'Rural road assets management and tracking system. Assets include poles, guardrail, traffic sign and traffic light. User can view 360 first person view along the road to examine road condition and surrounding area.',
    imageUrl: RM,
    url: 'https://rm.drr.go.th',
    tags: ['PHP', 'Drupal', 'Flash', 'Data Engineer', 'WebALP - Iwane'],
    year: 2017,
  },
  {
    title: 'DOL - IPL',
    desc: 'Landuse Management System',
    detail:
      'Landuse management and tracking system. Core features include edit polygon, search for particular area, view 360 scene of streets nearby.',
    imageUrl: DOL,
    url: 'http://dolview.dol.go.th/',
    tags: ['PHP', 'Symfony', 'Laravel', 'Data Engineer'],
    year: 2017,
  },
  {
    title: 'DOH - ITIM',
    desc: 'Highway Integrated Traffic Information Management System',
    detail:
      'Provide useful information about highway status and nearby POI for public use e.g. location of Gas station, accidents, traffic condition of each highway and recommended routes.',
    imageUrl: ITIM,
    url: 'https://play.google.com/store/apps/details?id=com.longdo.android.itim',
    tags: ['Java', 'Kotlin', 'Map SDK'],
    year: 2017,
    visible: false,
  },
  {
    title: 'DRR Onepage',
    desc: 'Single page web application to show road surrounded environment',
    detail:
      'Single web page that shows detailed information about roads environment e.g. constructions along the roads, intersections, road surface repair history, building and residences',
    imageUrl: ONEPAGE,
    url: 'http://rm.drr.go.th/onepage/',
    tags: ['Vanilla JS', 'Raphaël'],
    year: 2017,
    visible: false,
  },
  {
    title: 'TaggerBot',
    desc: 'Document classification tool',
    detail:
      'NSC and Microsoft Imagine Cup Award Winning. Automatically classify document into pre-defined groups. Support add/edit/remove sample documents manually and re-use those samples as new dataset for re-training. Also support searching documents by assigned tags, location, etc',
    imageUrl: TAGGERBOT,
    url: 'http://kmschool.thaissf.org/taggerbot/taggerbot-admin/web/login',
    tags: ['Python', 'PHP', 'Java', 'NLP'],
    year: 2015,
  },
  {
    title: 'GISTDA GO',
    desc: 'View satellite photos',
    detail:
      'GISTDA GO (Global Online) provides public access to satellite images from Thaichote satellite. The service is provided by Geo-Informatics and Space Technology Development Agency (Public Organization).',
    imageUrl: GISTDA_GO,
    url: 'https://play.google.com/store/apps/details?id=com.longdo.gistdago.android',
    tags: ['Java', 'Kotlin', 'Map SDK'],
    year: 2015,
  },
  {
    title: 'Open source Android MJpeg View',
    desc: 'Android customer View for playing MJpeg',
    detail:
      'Reading Jpeg images and display one by one using configured framerate. Also support multiple display modes.',
    imageUrl: MJPEG_LIB,
    url: 'https://github.com/perthcpe23/android-mjpeg-view',
    tags: ['Java', 'MJpeg'],
    year: 2015,
  },
  {
    title: 'Traffic camera server',
    desc: 'IP camera streaming server (HLS and MJpeg)',
    detail:
      'Streaming server developed using pure Java. It supports multiple input sources e.g. various IP camera brands, static images, etc.',
    imageUrl: CAMERA_SERVER,
    url: 'https://bma-itic1.iticfoundation.org/mjpeg2.php?camid=test',
    tags: ['Java', 'PHP', 'HLS', 'MJpeg'],
    year: 2015,
  },
  {
    title: 'Road cross section view',
    desc: 'Configurable road cross section on web',
    detail:
      'A small library display road cross section using Raphaël (SVG) library.',
    imageUrl: CROSS_SECTION,
    url: 'https://youtu.be/NQkoTIpTwRA',
    tags: ['Javascript', 'Raphaël'],
    year: 2015,
    visible: false,
  },
  {
    title: 'MIMO Projection Control System',
    desc: '[Senior project] Multiple Input to Multiple Output Projection Control System',
    detail:
      'Design and control how multiple input sources from different screens sharing will be displayed on multiple monitors/projectors.',
    imageUrl: MIMO,
    url: 'https://drive.google.com/drive/folders/18fCu7JI8kdOYWT9n4aKs8Y8YO0ybrMUG?usp=sharing',
    year: 2012,
    tags: ['Java', 'Swing', 'Network', 'MJpeg', 'Video Compression'],
  },
  {
    title: 'Multi-depot and product vehicle routing problem...',
    desc: '[Research] Optimization solver for multi-depot vehicle routing with precedence constraints and selective backhauling',
    detail:
      'Co-designed the optimization formula and algorithm for a PhD thesis on vehicle routing in animal feed manufacturing, and implemented the solver as a Golang CLI tool.',
    imageUrl: PHD_THESIS,
    url: 'https://www.researchgate.net/publication/384328470_Multi-depot_and_product_vehicle_routing_problem_with_precedence_constraint_and_selective_backhauling_in_animal_feed_manufacturing_industry',
    year: 2024,
    tags: ['Machine Learning', 'Golang', 'Optimization'],
  },
  {
    title: 'Workflow framework to support data analytics in cloud computing',
    desc: '[Internship] Co-author of a conference paper',
    detail:
      'Modify Rapid Miner to use Hadoop as compute engine instead of local CPU result in increasing capability to handle Big Data.',
    imageUrl: RAPID_MINER,
    url: 'https://www.researchgate.net/publication/261434541_Workflow_framework_to_support_data_analytics_in_cloud_computing',
    year: 2011,
    tags: ['Rapid Miner', 'Java', 'Hadoop', 'Mahout', 'Oozie'],
  },
];

export const logoCategories = [
  {
    title: 'Programming Languages',
    items: [
      { src: 'https://skillicons.dev/icons?i=go', alt: 'Golang' },
      { src: 'https://skillicons.dev/icons?i=dart', alt: 'Dart' },
      { src: 'https://skillicons.dev/icons?i=swift', alt: 'Swift' },
      { src: 'https://skillicons.dev/icons?i=kotlin', alt: 'Kotlin' },
      { src: 'https://skillicons.dev/icons?i=java', alt: 'Java' },
      { src: 'https://skillicons.dev/icons?i=py', alt: 'Python' },
      { src: 'https://skillicons.dev/icons?i=ts', alt: 'TypeScript' },
      { src: 'https://skillicons.dev/icons?i=js', alt: 'JavaScript' },
      { src: 'https://skillicons.dev/icons?i=php', alt: 'PHP' },
      { src: 'https://skillicons.dev/icons?i=bash', alt: 'Bash' },
    ],
  },
  {
    title: 'Mobile & Frontend',
    items: [
      { src: 'https://skillicons.dev/icons?i=flutter', alt: 'Flutter' },
      { src: 'https://skillicons.dev/icons?i=apple', alt: 'iOS' },
      { src: 'https://skillicons.dev/icons?i=androidstudio', alt: 'Android' },
      { src: 'https://skillicons.dev/icons?i=react', alt: 'React' },
      { src: 'https://skillicons.dev/icons?i=nextjs', alt: 'Next.js' },
      { src: 'https://skillicons.dev/icons?i=tailwind', alt: 'Tailwind' },
    ],
  },
  {
    title: 'Backend, APIs & AI/ML',
    items: [
      { src: 'https://skillicons.dev/icons?i=nodejs', alt: 'Node.js' },
      { src: 'https://skillicons.dev/icons?i=fastapi', alt: 'FastAPI' },
      { src: 'https://skillicons.dev/icons?i=laravel', alt: 'Laravel' },
      { src: 'https://skillicons.dev/icons?i=graphql', alt: 'GraphQL' },
      { src: 'https://skillicons.dev/icons?i=prisma', alt: 'Prisma' },
      { src: 'https://skillicons.dev/icons?i=tensorflow', alt: 'TensorFlow' },
    ],
  },
  {
    title: 'Databases, Search & Messaging',
    items: [
      { src: 'https://skillicons.dev/icons?i=postgres', alt: 'PostgreSQL' },
      { src: 'https://skillicons.dev/icons?i=mysql', alt: 'MySQL' },
      { src: 'https://skillicons.dev/icons?i=mongodb', alt: 'MongoDB' },
      { src: 'https://skillicons.dev/icons?i=redis', alt: 'Redis' },
      {
        src: 'https://skillicons.dev/icons?i=elasticsearch',
        alt: 'Elasticsearch',
      },
      { src: CLICKHOUSE, alt: 'ClickHouse' },
      { src: 'https://skillicons.dev/icons?i=kafka', alt: 'Kafka' },
    ],
  },
  {
    title: 'Cloud, Infrastructure & DevOps',
    items: [
      { src: 'https://skillicons.dev/icons?i=aws', alt: 'AWS' },
      { src: 'https://skillicons.dev/icons?i=gcp', alt: 'GCP' },
      { src: TENCENT_CLOUD, alt: 'Tencent Cloud' },
      { src: 'https://skillicons.dev/icons?i=firebase', alt: 'Firebase' },
      { src: 'https://skillicons.dev/icons?i=terraform', alt: 'Terraform' },
      { src: 'https://skillicons.dev/icons?i=docker', alt: 'Docker' },
      { src: 'https://skillicons.dev/icons?i=nginx', alt: 'Nginx' },
      { src: 'https://skillicons.dev/icons?i=linux', alt: 'Linux' },
    ],
  },
  {
    title: 'Tools & Version Control',
    items: [
      { src: 'https://skillicons.dev/icons?i=github', alt: 'GitHub' },
      { src: 'https://skillicons.dev/icons?i=gitlab', alt: 'GitLab' },
      { src: 'https://skillicons.dev/icons?i=gradle', alt: 'Gradle' },
      { src: 'https://skillicons.dev/icons?i=regex', alt: 'Regex' },
      { src: 'https://skillicons.dev/icons?i=ps', alt: 'Photoshop' },
    ],
  },
];

export const logos = logoCategories.flatMap((category) => category.items);

export const programmings = [
  { name: 'Flutter / Dart' },
  { name: 'Golang' },
  { name: 'Swift' },
  { name: 'Kotlin' },
  { name: 'Java' },
  { name: 'Javascript' },
  { name: 'Typescript' },
  { name: 'Python' },
  { name: 'PHP' },
];

export const tools = [
  { name: 'Vue.js' },
  { name: 'React.js' },
  { name: 'Next.js' },
  { name: 'OpenGL' },
  { name: 'WebGL' },
  { name: 'Hadoop' },
  { name: 'RabbitMQ' },
  { name: 'EFK' },
  { name: 'Kafka' },
  { name: 'Symfony' },
  { name: 'Laravel' },
  { name: 'Drupal' },
  { name: 'GIN' },
  { name: 'FastAPI' },
  { name: 'Three.js' },
  { name: 'Raphaël' },
  { name: 'AWS' },
  { name: 'GCP' },
  { name: 'Tencent Cloud' },
  { name: 'Antigravity CLI', color: '#00f3ff' },
  { name: 'Claude Code', color: '#00f3ff' },
  { name: 'Codex', color: '#00f3ff' },
  { name: 'Pi', color: '#00f3ff' },
  { name: 'OpenCode', color: '#00f3ff' },
  { name: 'LangGraph', color: '#00f3ff' },
];

export const databases = [
  { name: 'Mongo' },
  { name: 'PostgreSQL + PostGIS' },
  { name: 'MySQL' },
  { name: 'Elasticsearch' },
  { name: 'Redis' },
  { name: 'Clickhouse' },
];

export const other = [
  { name: 'Scalable Design' },
  { name: 'Software architecture' },
  { name: 'Design Pattern' },
  { name: 'Natural Language Processing - NLP' },
  { name: 'Machine Learning - ML' },
  { name: 'LLM' },
  { name: 'Agentic Workflow' },
  { name: 'Linux', color: '#00f3ff' },
  { name: 'DevOps', color: '#00f3ff' },
  { name: 'Network', color: '#00f3ff' },
  { name: '3D geometry', color: '#00f3ff' },
  { name: 'Computer security', color: '#00f3ff' },
];

export const careers = [
  {
    code: 'staygold',
    name: 'Staygold, Bitkub Longevity',
    title: 'Technology Director',
    date: 'Nov 2025 - Sep 2026 (11 months)',
    description: [
      'Joined as the first tech team member; built and mentored the Software Engineering, UX, and QA team from scratch to deliver planned features on schedule.',
      'Led the introduction of major features—including wearable health tracking and a custom Shopify-powered e-commerce store—increasing DAU 5x within 6 months.',
      'Provided hands-on development across apps, APIs, and DevOps while integrating AI services into both the product and internal workflows.',
      'Oversaw the full backend migration from AWS to Tencent Cloud and executed major infrastructure cost optimization.',
      'Hardened the platform into a stable, bug-free, self-sustaining system capable of running reliably without dedicated operational maintenance.',
    ],
    tags: [
      { name: 'Product Roadmap' },
      { name: 'Infrastructure' },
      { name: 'Team Building' },
      { name: 'Longevity' },
      { name: 'Full-stack' },
      { name: 'Flutter', color: 'secondary' },
      { name: 'Golang', color: 'secondary' },
      { name: 'Typescript', color: 'secondary' },
      { name: 'Next.js', color: 'secondary' },
      { name: 'AI', color: 'secondary' },
      { name: 'ML', color: 'secondary' },
      { name: 'Tencent Cloud', color: 'rgb(255 149 0)' },
      { name: 'Firebase', color: 'rgb(255 149 0)' },
    ],
  },
  {
    code: 'ooca',
    name: 'Ooca, Telemedica',
    title: 'Head of Product and Technology',
    date: 'Oct 2023 - Nov 2025 (2 years 1 month)',
    description: [
      'Built and mentored an in-house team of Product Managers, UX designers, developers, and QA from the ground up, replacing external contractors.',
      'Directed software architecture and transitioned legacy APIs to a serverless architecture, remediating security issues and restoring platform stability.',
      'Integrated AI solutions into new product features and internal operations while spearheading a major app redesign.',
      'Architected an integrated O2O system connecting physical clinics with online tele-mental health services, driving a 60%+ increase in monthly revenue.',
    ],
    tags: [
      { name: 'Head of Technology' },
      { name: 'Head of Product' },
      { name: 'Direction Planning' },
      { name: 'Feature Roadmap' },
      { name: 'Team Building' },
      { name: 'Mental Health' },
      { name: 'Full-stack' },
      { name: 'Flutter', color: 'secondary' },
      { name: 'Golang', color: 'secondary' },
      { name: 'Python', color: 'secondary' },
      { name: 'Typescript', color: 'secondary' },
      { name: 'Next.js', color: 'secondary' },
      { name: 'AI', color: 'secondary' },
      { name: 'ML', color: 'secondary' },
      { name: 'GCP', color: 'rgb(255 149 0)' },
      { name: 'Firebase', color: 'rgb(255 149 0)' },
      { name: 'Cloud Run', color: 'rgb(255 149 0)' },
      { name: 'Cloud SQL', color: 'rgb(255 149 0)' },
    ],
  },
  {
    code: 'pomelo',
    name: 'Pomelo Fashion',
    title: 'Software Engineering Director',
    date: 'May 2021 - Aug 2023 (2 years 4 months)',
    description: [
      'Managed and scaled mobile engineering teams (20–30 developers across native iOS, Android, and Flutter) and promoted to Software Engineering Director.',
      'Partnered with Product, QA, DevOps, and backend teams to plan and execute regional e-commerce product roadmaps.',
      'Formulated software architecture, defined code standards, led engineering programs, and conducted PoCs for emerging technologies.',
      'Provided hands-on expertise across native app development, backend API design, and DevOps (Terraform + AWS).',
    ],
    tags: [
      { name: 'Engineering Director' },
      { name: 'Engineering Manager' },
      { name: 'Direction Planning' },
      { name: 'Feature Roadmap' },
      { name: 'Team Building' },
      { name: 'Full-stack' },
      { name: 'Swift', color: 'secondary' },
      { name: 'Kotlin', color: 'secondary' },
      { name: 'Typescript', color: 'secondary' },
      { name: 'Terraform', color: 'secondary' },
      { name: 'AWS', color: 'secondary' },
      { name: 'Search', color: 'secondary' },
      { name: 'CDP', color: 'secondary' },
      { name: 'ML', color: 'secondary' },
      { name: 'ESC', color: 'rgb(255 149 0)' },
      { name: 'Beanstalk', color: 'rgb(255 149 0)' },
      { name: 'EC2', color: 'rgb(255 149 0)' },
      { name: 'Lambda', color: 'rgb(255 149 0)' },
      { name: 'WAF', color: 'rgb(255 149 0)' },
      { name: 'S3', color: 'rgb(255 149 0)' },
      { name: 'RDS', color: 'rgb(255 149 0)' },
      { name: 'Cloud Watch', color: 'rgb(255 149 0)' },
      { name: 'Cloud Front', color: 'rgb(255 149 0)' },
    ],
  },
  {
    code: 'insightera',
    name: 'InsightEra',
    title: 'Chief Technology Officer (CTO)',
    date: 'Feb 2019 - Jan 2021 (2 years)',
    description: [
      'Built and led a cross-functional team of engineers, BAs, PMs, and UX/UI designers, implementing Agile methodologies and a culture of continuous improvement.',
      'Developed product strategies and oversaw end-to-end delivery for social listening, large-scale data mining, and MarTech platforms.',
      'Led hands-on R&D and PoCs for in-house ML and NLP models—spanning text classification, intent recognition, and conversational chatbots.',
      'Expanded scope post-merger to oversee agency web implementations and technical operations for digital marketing campaigns.',
    ],
    tags: [
      { name: 'CTO' },
      { name: 'Coaching' },
      { name: 'Team Building' },
      { name: 'Culture' },
      { name: 'Company Direction Planning' },
      { name: 'Resource Management' },
      { name: 'Full-stack' },
      { name: 'Research and Development' },
      { name: 'Golang', color: 'secondary' },
      { name: 'Python', color: 'secondary' },
      { name: 'Node.js', color: 'secondary' },
      { name: 'Java', color: 'secondary' },
      { name: 'Kotlin', color: 'secondary' },
      { name: 'PHP', color: 'secondary' },
      { name: 'Vue.js', color: 'secondary' },
      { name: 'React.js', color: 'secondary' },
      { name: 'Elasticsearch', color: 'secondary' },
      { name: 'MongoDB', color: 'secondary' },
      { name: 'Redis', color: 'secondary' },
      { name: 'Swarm', color: 'secondary' },
      { name: 'Tensorflow', color: 'secondary' },
      { name: 'RabbitMQ', color: 'secondary' },
      { name: 'EFK', color: 'secondary' },
      { name: 'NLP', color: 'secondary' },
      { name: 'ML', color: 'secondary' },
      { name: 'DevOps', color: 'secondary' },
    ],
  },
  {
    code: 'metamedia',
    name: 'Metamedia',
    title: 'Senior Full-stack Developer',
    date: 'Oct 2013 - Jan 2019 (5 years 3 months)',
    description: [
      'Developed full-stack web, Android, backend API, and native desktop software across diverse client and internal projects.',
      'Built flagship geospatial R&D products, including the Longdo Map Android SDK (OpenGL ES) and Longdo Panorama 360° street-view engine (WebGL).',
      'Led project planning, requirement gathering, technical consulting with stakeholders, and coaching of junior developers.',
      'Installed, configured, and managed physical servers in the data center to support ongoing production projects.',
    ],
    tags: [
      { name: 'Full-stack Dev' },
      { name: 'Technical Consult' },
      { name: 'Project Management' },
      { name: 'Coaching' },
      { name: 'Research and Development' },
      { name: 'Android', color: 'secondary' },
      { name: 'Java', color: 'secondary' },
      { name: 'Kotlin', color: 'secondary' },
      { name: 'Node.js', color: 'secondary' },
      { name: 'Redis', color: 'secondary' },
      { name: 'Python', color: 'secondary' },
      { name: 'PHP', color: 'secondary' },
      { name: 'Hadoop', color: 'secondary' },
      { name: 'Elasticsearch', color: 'secondary' },
      { name: 'Memcache', color: 'secondary' },
      { name: 'Drupal', color: 'secondary' },
      { name: 'Symfony', color: 'secondary' },
      { name: 'Laravel', color: 'secondary' },
      { name: 'OpenGL', color: 'secondary' },
      { name: 'WebGL', color: 'secondary' },
      { name: 'Three.js', color: 'secondary' },
      { name: 'DevOps', color: 'secondary' },
      { name: 'PostgreSQL', color: 'secondary' },
      { name: 'PostGIS', color: 'secondary' },
      { name: 'MySQL', color: 'secondary' },
    ],
  },
];

export const heroStats = [
  {
    value: `${Math.round((new Date() - new Date('2013-08-01 00:00:00')) / (1000 * 60 * 60 * 24 * 365))}+ yrs`,
    label: 'building software',
  },
  { value: 'Techology Director', label: 'technical leadership' },
];

export const systemNodes = [
  { label: 'Leadership', value: 'Strategy, team building, delivery' },
  { label: 'Architecture', value: 'Mobile, APIs, cloud platforms' },
  { label: 'Engineering', value: 'Flutter, Go, TS, Python, Swift, Kotlin' },
  { label: 'Applied AI', value: 'Agents, LLM, ML, workflows' },
];
